module.exports = __webpack_public_path__ + "static/media/meals@3x.08d2cfa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/meals@3x.png
// module id = 668
// module chunks = 1